'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _popper = require('popper.js');

var _popper2 = _interopRequireDefault(_popper);

var _reactClickOutside = require('react-click-outside');

var _reactClickOutside2 = _interopRequireDefault(_reactClickOutside);

var _domHelper = require('../utils/domHelper');

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _index = require('../index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var babelPluginFlowReactPropTypes_proptype_Node = require('react').babelPluginFlowReactPropTypes_proptype_Node || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_CommonType = require('appkit-react-utils/commonType').babelPluginFlowReactPropTypes_proptype_CommonType || require('prop-types').any;

var babelPluginFlowReactPropTypes_proptype_TooltipProps = {
  /**
   * The content of Tooltip
   */
  content: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node.isRequired ? babelPluginFlowReactPropTypes_proptype_Node.isRequired : babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node).isRequired,

  /**
   * The placement of tooltip, 12 directions
   */
  placement: require('prop-types').oneOf(['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start']),
  position: require('prop-types').shape({}),

  /**
   * The event trigger to show tooltip
   */
  trigger: require('prop-types').oneOf(['hover', 'click', 'focus']),

  /**
   * whether tooltip should be closed if reference element clicked
   */
  clickToClose: require('prop-types').bool,

  /**
   * The delay time when mouse enter
   */
  mouseEnterDelay: require('prop-types').number,

  /**
   * The delay time when mouse leave
   */
  mouseLeaveDelay: require('prop-types').number,
  hideAfterMouseLeave: require('prop-types').bool,
  disabled: require('prop-types').bool,

  // visible?: boolean,
  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node.isRequired ? babelPluginFlowReactPropTypes_proptype_Node.isRequired : babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node).isRequired,

  /**
   * The tooltip card theme
   */
  tooltipTheme: require('prop-types').oneOf(['dark', 'light']),

  /**
   * Customize reference element style
   */
  refStyle: require('prop-types').shape({}),

  /**
   * Customize reference element classes
   */
  refClassName: require('prop-types').string,

  /**
   * To show or hide the arrow
   */
  hasArrow: require('prop-types').bool,

  /**
   * The callback function when tooltip show
   */
  onShow: require('prop-types').func,

  /**
   * The callback function when tooltip hide
   */
  onHide: require('prop-types').func,
  offset: require('prop-types').oneOfType([require('prop-types').number, require('prop-types').string]).isRequired,

  /**
   * The id of the dom element,which the tooltip content would be appended to. The container would be body if no containerid is assigned.
   */
  containerid: require('prop-types').string
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_TooltipProps', {
  value: babelPluginFlowReactPropTypes_proptype_TooltipProps,
  configurable: true
});

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.updateTooltipStyle = function (tooltip, position) {
      Object.keys(position).forEach(function (k) {
        var oppositePos = _this.getOppositePosition(k);
        if (oppositePos) {
          tooltip.style.removeProperty('transform');
          tooltip.style.setProperty(k, position[k]);
          tooltip.style.removeProperty(oppositePos);
        }
      });
    };

    _this.state = {
      showTooltip: false
    };
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          disabled = _props.disabled,
          _props$clickToClose = _props.clickToClose,
          clickToClose = _props$clickToClose === undefined ? false : _props$clickToClose,
          containerid = _props.containerid;

      this.container = document.getElementById(containerid) || document.body;
      if (this.props.trigger === 'click') {
        this.wrapper.addEventListener('click', function () {
          if (!disabled && !_this2.state.showTooltip) {
            _this2.showTooltip();
            return;
          }
          if (clickToClose && !disabled && _this2.state.showTooltip) {
            _this2.hideTooltip();
          }
        });
      }

      //react bug https://github.com/facebook/react/issues/10396
      this.inner.addEventListener('mouseleave', function () {
        _this2.handleMouseLeave();
      });
    }
  }, {
    key: '_checkPlacement',
    value: function _checkPlacement(currentPlacement, placements) {
      if (placements && placements.length > 0) {
        if (Array.from(placements).indexOf(currentPlacement) != -1) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'handleTrigger',
    value: function handleTrigger(eventType) {
      var _props$trigger = this.props.trigger,
          trigger = _props$trigger === undefined ? 'hover' : _props$trigger;

      if (trigger === eventType) {
        this.showTooltip();
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(e) {
      //clicking on tooltip content will be ignore
      var selector = '.a-tooltip-inner';
      if ((0, _domHelper.matches)(e.target, selector) || (0, _domHelper.isWithin)(e.target, selector)) {
        return;
      }

      this.hideTooltip();
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      var _props2 = this.props,
          _props2$trigger = _props2.trigger,
          trigger = _props2$trigger === undefined ? 'hover' : _props2$trigger,
          hideAfterMouseLeave = _props2.hideAfterMouseLeave;

      if (trigger === 'hover' && hideAfterMouseLeave) {
        this.hideTooltip();
      }
    }
  }, {
    key: 'getOppositePosition',
    value: function getOppositePosition(position) {
      switch (position) {
        case 'left':
          return 'right';
        case 'right':
          return 'left';
        case 'top':
          return 'bottom';
        case 'bottom':
          return 'top';
        default:
          return null;
      }
    }
  }, {
    key: 'onKeyPressHandler',
    value: function onKeyPressHandler() {}
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      if (this.props.trigger !== 'click') return;
      if (e.keyCode === _keyCode2.default.ENTER) {
        if (!this.state.showTooltip) {
          this.showTooltip();
        } else {
          this.hideTooltip();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      clearTimeout(this.hidetipID);
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      var _this3 = this;

      var _props3 = this.props,
          placement = _props3.placement,
          mouseEnterDelay = _props3.mouseEnterDelay,
          onShow = _props3.onShow,
          _props3$position = _props3.position,
          position = _props3$position === undefined ? {} : _props3$position,
          _props3$offset = _props3.offset,
          offset = _props3$offset === undefined ? null : _props3$offset,
          _props3$disabled = _props3.disabled,
          disabled = _props3$disabled === undefined ? false : _props3$disabled;

      if (disabled) {
        return;
      }
      this.popperNode = document.createElement('div');
      var container = this.container;
      container && container.appendChild(this.popperNode);
      var that = this;
      this.timeout = setTimeout(function () {
        _this3.setState({
          showTooltip: true
        });
        var tooltip = that.tooltip;
        var wrapper = that.wrapper;
        var targetChildren = wrapper ? wrapper.children : [];
        var target = targetChildren.length === 1 ? targetChildren[0] : wrapper;
        _this3.popperJS = !disabled && new _popper2.default(target, tooltip, {
          placement: that.props.placement ? that.props.placement : 'bottom',
          modifiers: Object.assign({}, {
            offset: {
              enable: true,
              offset: offset
            }
          }),
          onCreate: function onCreate(data) {
            var _tooltip = _this3.tooltip;
            if (!_this3._checkPlacement(data.placement, _tooltip.classList)) {
              // IE 11 browser compatible issue: DOMTokenList.replace is not supported on IE 11
              _tooltip.className = _tooltip.className.replace(placement, data.placement);
            }
            //To check the positon
            // Object.keys(position).forEach(k => {
            //   //If position is in current style, then override it.
            //   if (_tooltip.style[k]) {
            //     _tooltip.style.setProperty(k, position[k]);
            //   } else {
            //     // If the position is not in current style, check the opposite position
            //     // and remove it, then set the new position.
            //     let oppositePos = this.getOppositePosition(k);
            //     if (oppositePos) {
            //       _tooltip.style.setProperty(k, position[k]);
            //       _tooltip.style.removeProperty(oppositePos);
            //     }
            //   }
            // });
            _this3.updateTooltipStyle(_tooltip, position);

            _this3.popperJS.scheduleUpdate();
          },
          onUpdate: function onUpdate(data) {
            var _tooltip = _this3.tooltip;
            if (_tooltip && _tooltip.classList) {
              var classList = _this3.tooltip.classList;
              _this3.updateTooltipStyle(_tooltip, position);
              if (!_this3._checkPlacement(data.placement, classList)) {
                // IE 11 browser compatible issue: DOMTokenList.replace is not supported on IE 11
                _tooltip.className = _tooltip.className.replace(classList[classList.length - 1], data.placement);
              }
            }
          }
        });
        if (onShow) onShow();
      }, mouseEnterDelay);
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      var _this4 = this;

      if (!this.popperNode) return;

      var _props4 = this.props,
          mouseLeaveDelay = _props4.mouseLeaveDelay,
          onHide = _props4.onHide,
          disabled = _props4.disabled;

      if (disabled) {
        return;
      }

      clearTimeout(this.timeout);
      if (this.state.showTooltip) {
        this.hidetipID = setTimeout(function () {
          _this4.setState({ showTooltip: false });
          _this4.onAfterLeave();
          if (onHide) onHide();
          // remove child after delay
          var container = _this4.container;
          container && _this4.popperNode && container.removeChild(_this4.popperNode);
          _this4.popperNode = null;
        }, mouseLeaveDelay);
      }
    }
  }, {
    key: 'onAfterLeave',
    value: function onAfterLeave() {
      if (this.popperJS) {
        this.popperJS.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this5 = this;

      var _props5 = this.props,
          children = _props5.children,
          content = _props5.content,
          disabled = _props5.disabled,
          _props5$placement = _props5.placement,
          placement = _props5$placement === undefined ? 'bottom' : _props5$placement,
          _props5$tooltipTheme = _props5.tooltipTheme,
          tooltipTheme = _props5$tooltipTheme === undefined ? 'dark' : _props5$tooltipTheme,
          style = _props5.style,
          refStyle = _props5.refStyle,
          className = _props5.className,
          refClassName = _props5.refClassName,
          position = _props5.position,
          _props5$hasArrow = _props5.hasArrow,
          hasArrow = _props5$hasArrow === undefined ? true : _props5$hasArrow,
          clickToClose = _props5.clickToClose,
          trigger = _props5.trigger,
          onShow = _props5.onShow,
          onHide = _props5.onHide,
          offset = _props5.offset,
          mouseEnterDelay = _props5.mouseEnterDelay,
          mouseLeaveDelay = _props5.mouseLeaveDelay,
          hideAfterMouseLeave = _props5.hideAfterMouseLeave,
          otherProps = _objectWithoutProperties(_props5, ['children', 'content', 'disabled', 'placement', 'tooltipTheme', 'style', 'refStyle', 'className', 'refClassName', 'position', 'hasArrow', 'clickToClose', 'trigger', 'onShow', 'onHide', 'offset', 'mouseEnterDelay', 'mouseLeaveDelay', 'hideAfterMouseLeave']);

      var tooltipClasses = (0, _classnames3.default)(className, 'a-tooltip', (_classnames = {}, _defineProperty(_classnames, 'a-' + tooltipTheme + '-panel', tooltipTheme), _defineProperty(_classnames, 'a-tooltip-show', this.state.showTooltip), _classnames), ['' + placement]);
      var refClasses = (0, _classnames3.default)('a-tooltip-ref', refClassName);
      var level = (0, _index.getCurrentLevel)();
      var tooltipInnerClassName = (0, _classnames3.default)('a-tooltip-inner', level);
      var tooltipArrowClassName = (0, _classnames3.default)('a-tooltip-arrow', level);

      return _react2.default.createElement(
        'div',
        { className: refClasses, style: refStyle },
        _react2.default.createElement(
          'div',
          Object.assign({
            tabIndex: '0' // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
            , onKeyPress: this.onKeyPressHandler.bind(this),
            onKeyDown: this.onKeyDown.bind(this),
            onFocus: this.handleTrigger.bind(this, 'focus'),
            onMouseEnter: this.handleTrigger.bind(this, 'hover'),
            className: 'a-tooltip-ref-inner',
            ref: function ref(node) {
              return _this5.inner = node;
            }
          }, otherProps),
          _react2.default.createElement(
            'span',
            {
              ref: function ref(node) {
                return _this5.wrapper = node;
              }
            },
            children
          )
        ),
        this.state.showTooltip && !disabled && this.popperNode && _reactDom2.default.createPortal(_react2.default.createElement(
          'div',
          { ref: function ref(node) {
              return _this5.tooltip = node;
            }, className: tooltipClasses, style: style },
          hasArrow && _react2.default.createElement('div', { className: tooltipArrowClassName, 'x-arrow': hasArrow ? 1 : 0 }),
          _react2.default.createElement(
            'div',
            { className: tooltipInnerClassName },
            content
          )
        ), this.popperNode)
      );
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.defaultProps = {
  hideAfterMouseLeave: true
};


Tooltip.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  content: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  placement: _propTypes2.default.oneOf(['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']),
  position: _propTypes2.default.object,
  trigger: _propTypes2.default.string,
  clickToClose: _propTypes2.default.bool,
  mouseEnterDelay: _propTypes2.default.number,
  mouseLeaveDelay: _propTypes2.default.number,
  hideAfterMouseLeave: _propTypes2.default.bool,
  tooltipTheme: _propTypes2.default.string,
  refStyle: _propTypes2.default.object,
  refClassName: _propTypes2.default.string,
  // visible: PropTypes.bool,
  disabled: _propTypes2.default.bool,
  onShow: _propTypes2.default.func,
  onHide: _propTypes2.default.func
};

exports.default = (0, _reactClickOutside2.default)(Tooltip);